// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-store{background-attachment:fixed!important;background-color:#fafafa!important;background-image:url(/zazos-store-bg.svg)!important;background-size:cover!important;--max-width:1160px;padding-left:16px;padding-right:16px}.layout-store__topbar{margin-left:auto;margin-right:auto;max-width:100%;width:var(--max-width)}.layout-store__footer{margin-left:auto;margin-right:auto;max-width:var(--max-width);width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
